import React, { useState, useRef, useEffect } from "react";
import closeIcon from "./../../assets/Images/Navbar/close.png";
import logo from "../../assets/Images/LoaderLogo.png";
import AuthService from "../../Services/AuthService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from '@react-oauth/google';

import view from "./../../assets/Images/Navbar/view.png";
import hide from "./../../assets/Images/Navbar/hide.png";
import "./Authentication.css";
import AuthTypeSelector from "./AuthTypeSelector";
const Authentication = ({ otpVerification, closeModal = () => { }, isSignup: propIsSignup, setIsSignup: propSetIsSignup }) => {
  const [isSignup, setIsSignupState] = useState(propIsSignup || "firstpage");

  useEffect(() => {
    if (propIsSignup) {
      setIsSignupState(propIsSignup);
    }
  }, [propIsSignup]);

  const setIsSignup = (val) => {
    setIsSignupState(val);
    if (propSetIsSignup) {
      propSetIsSignup(val);
    }
  };

  const [otpSwitch, setOtpSwitch] = useState(Boolean(otpVerification));
  const [timeLeft, setTimeLeft] = useState(0); // 10 min

  const [LoginError, setLoginError] = useState('');
  const [SignupError, setSignupError] = useState('');
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [passwordShow2, setPasswordShow2] = useState(false);
  const [passwordShow3, setPasswordShow3] = useState(false);
  const [passwordShow4, setPasswordShow4] = useState(false);

  const [VerifyLoader, setVerifyLoader] = useState(false);
  const [OTP, setOTP] = useState("");
  const [OTPError, setOTPError] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [timer, setTimer] = useState(600); // 10 minutes
  const [canResend, setCanResend] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [signupLoading, setSignupLoading] = useState(false);
  const [verifyEmailLoading, setVerifyEmailLoading] = useState(false);
  const [submitOtpLoading, setSubmitOtpLoading] = useState(false);
  const [newPasswordError, setNewPasswordError] = useState("");
  const [conformNewPasswordError, setConformNewPasswordError] = useState("");
  const [token, setToken] = useState("");
  const [userDetails, setUserDetails] = useState();
  const validatePassword = (value) =>
    /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/.test(value);
  const navigate = useNavigate();
  //   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    setSignupError("");

    if (!userName.trim()) setUserNameError("Username is required");
    if (!firstName.trim()) setFirstNameError("First Name is required");
    if (!lastName.trim()) setLastNameError("Last Name is required");
    if (!email.trim()) setEmailError("Email is required");
    if (!password.trim()) setPasswordError("Password is required");
    if (!confirmPassword.trim()) setConfirmPasswordError("Confirm Password is required");
    if (!phone.trim()) setPhoneError("Phone number is required");

    if (
      userNameError ||
      firstNameError ||
      lastNameError ||
      emailError ||
      passwordError ||
      confirmPasswordError ||
      phoneError ||
      !isChecked ||
      !userName.trim() ||
      !firstName.trim() ||
      !lastName.trim()
    ) {
      toast.error("Please correct the highlighted errors");
      return;
    }

    setSignupLoading(true);
    let obj = {
      email,
      password,
      confirmPassword,
      countryCode,
      phoneNumber: phone,
      name: userName,
      firstName,
      middleName,
      lastName,
      userType: "user",
    };
    console.log(obj, 'ksksksksksk')
    try {
      const response = await AuthService.Signup(obj);

      if (response?.data) {
        setTimeout(() => {
          setOtpSwitch(true);
        }, 500);
      } else {
        const errorMsg = typeof response === 'string' ? response.replace('Error: ', '') : (response.message || "Signup failed");
        setSignupError(errorMsg);
      }
    } catch (error) {
      console.error("Signup error:", error);
      setSignupError("Something went wrong during signup");
    } finally {
      setSignupLoading(false);
    }
  };

  const handleUserName = (e) => {
    let value = e.target.value;

    value = value.replace(/[^A-Za-z0-9]/g, "");

    setUserName(value);

    if (!value.trim()) {
      setUserNameError("Username is required");
    } else if (value.length < 3) {
      setUserNameError("Username must be at least 3 characters");
    } else {
      setUserNameError("");
    }
  };

  const handleFirstName = (e) => {
    let value = e.target.value;
    value = value.replace(/[^A-Za-z ]/g, "");
    setFirstName(value);
    if (!value.trim()) setFirstNameError("First Name is required");
    else setFirstNameError("");
  };

  const handleMiddleName = (e) => {
    let value = e.target.value;
    value = value.replace(/[^A-Za-z ]/g, "");
    setMiddleName(value);
  };

  const handleLastName = (e) => {
    let value = e.target.value;
    value = value.replace(/[^A-Za-z ]/g, "");
    setLastName(value);
    if (!value.trim()) setLastNameError("Last Name is required");
    else setLastNameError("");
  };
  const ALLOWED_EMAIL_DOMAINS = [
    "gmail.com",
    "gmail.co.in",

    "yahoo.com",
    "yahoo.co.in",

    "outlook.com",
    "outlook.co.in",

    "hotmail.com",
    "hotmail.co.in",

    "live.com",
    "live.co.in",

    "icloud.com",
    "icloud.co.in",

    "rediffmail.com",
    "rediffmail.co.in",

    "zoho.com",
    "zoho.co.in",

    "protonmail.com",
    "protonmail.co.in",

    "yopmail.com",
    "yopmail.co.in",

    "gmail.io",
    "yahoo.io",
    "outlook.io",
    "hotmail.io",
    "live.io",
    "icloud.io",
    "rediffmail.io",
    "zoho.io",
    "protonmail.io",
    "yopmail.io",
  ];

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return false;

    const domain = email.split("@")[1]?.toLowerCase();
    return ALLOWED_EMAIL_DOMAINS.includes(domain);
  };

  const handleEmailChange = (e) => {
    let value = e.target.value;

    value = value.replace(/\s+/g, "");

    setEmail(value);

    if (!value) {
      setEmailError("Email is required");
    } else if (!validateEmail(value)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };


  const handlePasswordChange = (e) => {
    const value = e.target.value
    setPassword(value.trim());
    if (!validatePassword(value)) {
      setPasswordError(
        "Password must be at least 8 characters long, and include at least one number and one special character."
      );
    } else {
      setPasswordError("");
    }
  };
  const handleConfirmPassword = (e) => {
    const value = e.target.value
    setConfirmPassword(value.trim());
    if (password !== value) {
      setConfirmPasswordError(" Password and Confirm Password do not match.");
    } else {
      setConfirmPasswordError("");
    }
  };
  const handlePhoneNumber = (e) => {
    let value = e.target.value;

    if (value.includes(" ")) return;

    value = value.replace(/\D/g, "").slice(0, 10);

    setPhone(value);

    if (value.length !== 10) {
      setPhoneError("Phone number must be 10 digits");
    } else {
      setPhoneError("");
    }
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };
  const handleToggle = () => {
    setIsSignup("login");
    setEmail('')
    setPassword('')
    setEmailError('')
    setPasswordError('')
    setSignupError('')
  }
  const handleSwitch = () => {
    setIsSignup("signup")
    setEmail('')
    setPassword('')
    setEmailError('')
    setPasswordError('')
    setLoginError('')
  };
  const handleForgot = () => {
    setIsSignup("forgot")
    setEmail('')
    setPassword('')
    setEmailError('')
    setPasswordError('')
  };

  const handleResendotp = async () => {
    if (timeLeft > 0) return;

    try {
      const response = await AuthService.resendOtp({ email });

      if (response.data) {
        setOtp(["", "", "", "", "", ""]);
        setTimeLeft(60);
        toast.success("OTP sent successfully");
      } else {
        toast.error(typeof response === 'string' ? response.replace('Error: ', '') : "Failed to resend OTP");
      }
    } catch (error) {
      toast.error("Something went wrong while resending OTP");
    }
  };
  useEffect(() => {
    if (timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    if (!emailError?.trim() && !passwordError?.trim() && email?.trim() && password?.trim()) {
      setLoginLoading(true);
      const obj = { email, password };
      try {
        const response = await AuthService.Login(obj);
        if (response?.data?.message == "Success") {
          if (response?.data?.data?.doCityUsersDetails) {
            localStorage.setItem("token", response.data.data.token);
            localStorage.removeItem("docity_onboarding_completed");
            localStorage.setItem(
              "userDetails",
              JSON.stringify(response.data.data.doCityUsersDetails)
            );
            // toast.success("Login Successfully");
            setLoginError("Logged in successfully");
            resetForm();
            closeModal();
            setIsSignup("login")
            setToken(response.data.data.token);
            setUserDetails(response.data.data.doCityUsersDetails);
            navigate("/");
            setTimeout(() => {
              toast.success("Logged in successfully");
              refresh();
            }, 100);
          } else {
            setLoginError("Please sign in with your user credentials.");
          }
        } else {
          const errMsg = typeof response === 'string' ? response.replace('Error: ', '') : (response?.message || "Login failed");

          if (errMsg.toLowerCase().includes("not found") || errMsg.toLowerCase().includes("does not exist") || errMsg.toLowerCase().includes("no user") || errMsg.toLowerCase().includes("register")) {
            toast.error("Account not found. Please register to continue.");
            setLoginError("");
            setPassword("");
            setIsSignup("signup");
          } else if (errMsg.toLowerCase().includes("please verify otp") || errMsg.toLowerCase().includes("user not active") || errMsg.toLowerCase().includes("verify your otp")) {
            toast.info("Please verify your OTP. A verification code has been sent to your email.");
            setLoginError("");
            setOtpSwitch(true);
            setOtp(["", "", "", "", "", ""]);
            AuthService.resendOtp({ email }).then((res) => {
              if (res.data) {
                setTimeLeft(60);
              }
            }).catch(err => {
              console.error("Auto resend OTP failed:", err);
            });
          } else {
            setLoginError(errMsg);
          }
        }
      } catch (error) {
        console.error("Login error:", error);
        setLoginError("Login failed. Please try again.");
      } finally {
        setLoginLoading(false);
      }
    } else {
      toast.error("Invalid Credentials");
    }
  };
  const handleVerifyEmailId = async (e) => {
    e.preventDefault();
    setEmailError("");
    if (!email?.trim()) {
      setEmailError("Enter Email Address.");
    } else {
      setVerifyEmailLoading(true);
      let obj = {
        email: email.trim(),
      };
      try {
        const response = await AuthService.forgotPassword(obj);
        if (response && response.data) {
          toast.success(`OTP has been sent to ${email}`);
          setIsSignup("verifyEmail");
          setEmailError("");
        } else {
          const errorMsg = typeof response === 'string'
            ? response.replace(/^Error:\s*/, '')
            : (response?.message || response?.error || "Verification failed. Please check your email.");
          setEmailError(errorMsg);
          toast.error(errorMsg);
        }
      } catch (error) {
        console.error("Verify email error:", error);
        const errorMsg = error?.message || "Something went wrong";
        setEmailError(errorMsg);
        toast.error(errorMsg);
      } finally {
        setVerifyEmailLoading(false);
      }
    }
  };
  const submitOtp = async (e) => {
    e.preventDefault();
    setOTPError("");
    setNewPasswordError("");
    setConformNewPasswordError("");

    let isValid = true;
    const OTPVal = otp.join("");

    if (OTPVal.length < 6 || otp.includes("")) {
      setOTPError("OTP is required (must be 6 digits)");
      isValid = false;
    }

    if (!newPassword) {
      setNewPasswordError("New Password is Required");
      isValid = false;
    } else if (!validatePassword(newPassword)) {
      setNewPasswordError(
        "Password must be at least 8 characters, and include one number and one special character."
      );
      isValid = false;
    }

    if (!confirmNewPassword) {
      setConformNewPasswordError("Confirm Password is required");
      isValid = false;
    } else if (newPassword !== confirmNewPassword) {
      setConformNewPasswordError("Passwords do not match");
      isValid = false;
    }

    if (isValid) {
      setSubmitOtpLoading(true);
      const obj = {
        otp: OTPVal,
        email: email.trim(),
        newPassword,
      };

      try {
        const response = await AuthService.changePassword(obj);
        if (response && response.data) {
          toast.success("Password changed successfully");
          setIsSignup("login");
          setOtp(["", "", "", "", "", ""]);
          setNewPassword("");
          setConfirmNewPassword("");
          setOTPError("");
          setNewPasswordError("");
          setConformNewPasswordError("");
        } else {
          const errorMsg = typeof response === 'string'
            ? response.replace(/^Error:\s*/, '')
            : (response?.message || response?.error || "Password change was unsuccessful. Please try again.");
          setOTPError(errorMsg);
          toast.error(errorMsg);
        }
      } catch (error) {
        const errorMsg = error?.message || "An error occurred. Please try again.";
        setOTPError(errorMsg);
        toast.error(errorMsg);
      } finally {
        setSubmitOtpLoading(false);
      }
    }
  };
  const handleOTP = (e) => {
    const value = e.target.value;
    setOTP(value);
    setOTPError(value ? "" : "OTP Is Required");
  };
  const handleOtpChange2 = (e, index) => {
    let rawValue = e.target.value.replace(/[^0-9]/g, "");
    if (rawValue.length > 1) {
      const digits = rawValue.slice(0, 6).split("");
      const newOtp = [...otp];
      digits.forEach((d, i) => {
        newOtp[i] = d;
      });
      setOtp(newOtp);
      setOTPError("");
      const nextIdx = Math.min(digits.length, 5);
      inputRefs.current[nextIdx]?.focus();
      return;
    }

    if (!rawValue) {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      return;
    }

    const lastChar = rawValue.slice(-1);
    const newOtp = [...otp];
    newOtp[index] = lastChar;
    setOtp(newOtp);
    setOTPError("");

    if (lastChar && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleOtpChange = (e, index) => {
    let rawValue = e.target.value.replace(/[^0-9]/g, "");
    if (rawValue.length > 1) {
      const digits = rawValue.slice(0, 6).split("");
      const newOtp = [...otp];
      digits.forEach((d, i) => {
        newOtp[i] = d;
      });
      setOtp(newOtp);
      setOTPError("");
      const nextIdx = Math.min(digits.length, 5);
      inputRefs.current[nextIdx]?.focus();
      return;
    }

    if (!rawValue) {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      setOTPError(newOtp.includes("") ? "OTP is required" : "");
      return;
    }

    const lastChar = rawValue.slice(-1);
    const newOtp = [...otp];
    newOtp[index] = lastChar;
    setOtp(newOtp);
    setOTPError("");

    if (lastChar && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };
  const verifyOtp = async () => {
    const OTP = otp.join("");

    if (OTP.length !== 6 || otp.includes("")) {
      setOTPError("Please enter a valid 6-digit OTP");
      toast.error("Please enter a valid OTP.");
      return;
    }

    try {
      const response = await AuthService.verifyOtp({ email, otp: OTP });
      console.log(response, 'AuthService')
      if (response.data) {
        localStorage.setItem('token', response.data.data.token);
        localStorage.removeItem("docity_onboarding_completed");
        localStorage.setItem('userDetails', JSON.stringify(response.data.data.doCityUsersDetails));
        setToken(response.data.data.token);
        setUserDetails(response.data.data.doCityUsersDetails);
        closeModal();
        navigate('/');
        refresh();
        setTimeout(() => {
          refresh();
        }, 2000);
      } else {
        const errorMsg = typeof response === 'string' ? response.replace('Error: ', '') : (response.message || "Invalid OTP");
        toast.error(errorMsg);
        setOTPError(errorMsg);
      }
    } catch (error) {
      toast.error("Something went wrong while verifying OTP");
      console.error(error);
    }
  };
  const refresh = () => {
    window.location.reload();
  };
  const handleNewPasswordChange = (e) => {
    const value = e.target.value?.trim();
    setNewPassword(value);
    if (!validatePassword(value)) {
      setNewPasswordError(
        "Password must be at least 8 characters,and include one number and one special character."
      );
    } else {
      setNewPasswordError("");
    }
  };
  const handleConfirmNewPasswordChange = (e) => {
    const value = e.target.value?.trim();
    setConfirmNewPassword(value);
    if (newPassword !== value) {
      setConformNewPasswordError("Password Must Be Equal To Conform Password");
    } else {
      setConformNewPasswordError("");
    }
  };
  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const res = await AuthService.googleLogin({
        idToken: credentialResponse.credential
      });

      if (res.data && res.data.isNewUser) {
        toast.info("No account found with this email. Please complete registration.");
        setIsSignup("signup"); // Redirect to Signup view

        // Auto-fill fields from backend response
        setEmail(res.data.googleData.email || "");
        setFirstName(res.data.googleData.firstName || "");
        setLastName(res.data.googleData.lastName || "");
        // Assuming the backend might send middleName, otherwise default to empty
        setMiddleName(res.data.googleData.middleName || "");

        return;
      }
      // Standard Login Logic (matching your handleLoginSubmit)
      if (res?.data?.message === "Success") {
        console.log(res?.data, 'res?.data')
        const authData = res.data.data;
        if (authData.doCityUsersDetails) {
          localStorage.setItem("token", authData.token);
          localStorage.removeItem("docity_onboarding_completed");
          localStorage.setItem("userDetails", JSON.stringify(authData.doCityUsersDetails));

          toast.success("Logged in with Google!");
          closeModal();
          navigate("/");
          refresh();
        } else {
          toast.error("Please sign in with your user credentials.");
        }
      } else {
        toast.error(typeof res === 'string' ? res : "Google authentication failed.");
      }
    } catch (error) {
      console.error("Google Success Error:", error);
      toast.error("An error occurred during Google sign-in.");
    }
  };
  const resetForm = () => {
    setEmail("");
    setPassword("");
    setEmailError("");
    setPasswordError("");
    setIsChecked(false);
    setCountryCode("+91");
    setPhone("");
    setPhoneError("");
    setConfirmPassword("");
    setConfirmPasswordError("");
    setUserName("");
    setUserNameError("");
    setFirstName("");
    setFirstNameError("");
    setMiddleName("");
    setLastName("");
    setLastNameError("");
  };
  const toggleLogin = () => {
    resetForm();
    setIsSignup(false);
  };
  const toggleSignup = () => {
    resetForm();
    setIsSignup(true);
  };
  const isSignUpDisabled =
    !(userName && userName.trim()) ||
    !(firstName && firstName.trim()) ||
    !(lastName && lastName.trim()) ||
    !(email && email.trim()) ||
    !(password && password.trim()) ||
    !(confirmPassword && confirmPassword.trim()) ||
    !(phone && String(phone).replace(/\D/g, '').length === 10) ||
    !isChecked ||
    !!(userNameError && userNameError.trim()) ||
    !!(firstNameError && firstNameError.trim()) ||
    !!(lastNameError && lastNameError.trim()) ||
    !!(emailError && emailError.trim()) ||
    !!(passwordError && passwordError.trim()) ||
    !!(confirmPasswordError && confirmPasswordError.trim()) ||
    !!(phoneError && phoneError.trim());

  return (
    <div>
      {otpSwitch == false ? (
        <div>
          {isSignup === "firstpage" && (
            <AuthTypeSelector
              setIsSignup={setIsSignup}
              resetForm={resetForm}
              closeModal={closeModal}
            />
          )}
          {isSignup == "signup" ? (
            <div className="login-form signup-form-wide">
              <div className="close-icon" onClick={closeModal} style={{ cursor: "pointer" }}>
                <img src={closeIcon} alt="Close" onClick={closeModal} />
              </div>
              <div className="login-logo col-md-12">
                <div className="row ">
                  <img className="logoImage" src={logo} />
                  <h4 >User Registration</h4>
                </div>
              </div>
              <div>
                <span className="registrationPagedetails-Text">Please fill in your details</span>
              </div>
              <form onSubmit={handleSignupSubmit}>
                <div className="signup-grid-fields">
                  <div className="signup-field-group">
                    <div className="form-field">
                      <input
                        type="text"
                        className="user-login"
                        placeholder="Enter your username"
                        value={userName}
                        onChange={handleUserName}
                      />
                    </div>
                    {userNameError && <p className="error">{userNameError}</p>}
                  </div>

                  <div className="signup-field-group">
                    <div className="form-field">
                      <input
                        type="text"
                        className="user-login"
                        placeholder="Enter your first name"
                        value={firstName}
                        onChange={handleFirstName}
                      />
                    </div>
                    {firstNameError && <p className="error">{firstNameError}</p>}
                  </div>

                  <div className="signup-field-group">
                    <div className="form-field">
                      <input
                        type="text"
                        className="user-login"
                        placeholder="Enter your middle name (optional)"
                        value={middleName}
                        onChange={handleMiddleName}
                      />
                    </div>
                  </div>

                  <div className="signup-field-group">
                    <div className="form-field">
                      <input
                        type="text"
                        className="user-login"
                        placeholder="Enter your last name"
                        value={lastName}
                        onChange={handleLastName}
                      />
                    </div>
                    {lastNameError && <p className="error">{lastNameError}</p>}
                  </div>

                  <div className="signup-field-group">
                    <div className="form-field">
                      <input
                        type="text"
                        className="email-login"
                        placeholder="Enter your email"
                        value={email}
                        onChange={handleEmailChange}
                      />
                    </div>
                    {emailError && <p className="error">{emailError}</p>}
                  </div>

                  <div className="signup-field-group">
                    <div className="form-field d-flex align-items-center">
                      <div
                        style={{
                          padding: '0 10px',
                          backgroundColor: 'var(--color-frosted-silver-sage)',
                          border: '1px solid #e5e7eb',
                          borderRadius: '8px 0 0 8px',
                          borderRight: 'none',
                          color: 'var(--color-oxford-blue)',
                          fontSize: '1rem',
                          height: '48px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '55px',
                          fontWeight: '500'
                        }}
                      >
                        +91
                      </div>
                      <input
                        type="number"
                        className="phone-login"
                        placeholder="Enter your phone number"
                        value={phone}
                        onChange={handlePhoneNumber}
                        style={{ borderRadius: '0 8px 8px 0', flex: 1, minWidth: 0, height: '48px' }}
                      />
                    </div>
                    {phoneError && <p className="error">{phoneError}</p>}
                  </div>

                  <div className="signup-field-group">
                    <div className="password-container">
                      <input
                        type={passwordShow3 ? "text" : "password"}
                        className="password-login"
                        placeholder="Enter your password"
                        value={password}
                        onChange={handlePasswordChange}
                      />
                      <span
                        className="toggle-password"
                        onClick={() => setPasswordShow3(!passwordShow3)}
                      >
                        <img
                          src={passwordShow3 ? view : hide}
                          width={20}
                          alt="Toggle visibility"
                        />
                      </span>
                    </div>
                    {passwordError && <p className="error">{passwordError}</p>}
                  </div>

                  <div className="signup-field-group">
                    <div className="password-container">
                      <input
                        type={passwordShow2 ? "text" : "password"}
                        className="password-login"
                        placeholder="Confirm your password"
                        value={confirmPassword}
                        onChange={handleConfirmPassword}
                      />
                      <span
                        className="toggle-password"
                        onClick={() => setPasswordShow2(!passwordShow2)}
                      >
                        <img
                          src={passwordShow2 ? view : hide}
                          width={20}
                          alt="Toggle visibility"
                        />
                      </span>
                    </div>
                    {confirmPasswordError && (
                      <p className="error">{confirmPasswordError}</p>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="terms-container" style={{ padding: '10px' }}>
                    <div className="form-check d-flex align-items-center justify-content-start gap-2">
                      <div className="custom-terms-checkbox flex-shrink-0" onClick={() => setIsChecked(!isChecked)}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="termsCheckbox"
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          readOnly
                        />
                        <span className={`checkbox-box ${isChecked ? "checked" : ""}`}>
                          {isChecked && "✓"}
                        </span>
                      </div>
                      <span className="form-check-label text-start" style={{ fontSize: '14px', lineHeight: '1.4' }}>
                        I have read and agree to the
                        <a
                          href="/#/TermsAndConditions"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: 'var(--color-oxford-blue)', fontWeight: '600', textDecoration: 'underline', marginLeft: '5px' }}
                        >
                          Terms & Conditions
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                {SignupError && <p className="setLoginErrroColor text-center">{SignupError}</p>}
                <div className="row setCenterTheButton mt-2">
                  <div className="col-md-3">
                    <button
                      className={`btn-verify-email ${signupLoading ? 'loading' : ''} ${isSignUpDisabled ? 'btn-verify-email--disabled' : ''}`}
                      disabled={isSignUpDisabled || signupLoading}
                    >
                      {signupLoading ? (
                        <>
                          <div className="spinner"></div>
                          Signing Up...
                        </>
                      ) : (
                        'Sign Up'
                      )}
                    </button>
                  </div>
                </div>
                <div className="register">
                  <span>
                    Already have an account?{" "}
                    <span className="pl-4 text-decoration-underline" style={{ cursor: "pointer" }} onClick={handleToggle}>
                      LogIn
                    </span>
                  </span>
                </div>
              </form>
            </div>
          ) : isSignup == "login" ? (
            <div className="login-form">
              <div className="close-icon" onClick={closeModal} style={{ cursor: "pointer" }}>
                <img src={closeIcon} alt="Close" onClick={closeModal} />
              </div>
              <div className="login-logo col-md-12">
                <div className="row ">
                  <img className="logoImage" src={logo} />
                  <h4 >Welcome Back!</h4>
                </div>
              </div>

              <span className="registrationPagedetails-Text">Please enter your login details below</span>
              <form onSubmit={handleLoginSubmit}>
                <div className="email-input">
                  <input
                    type="text"
                    className="email-login"
                    placeholder="Enter your email"
                    value={email}
                    onChange={handleEmailChange}
                  />
                </div>
                {emailError && <p className="error">{emailError}</p>}
                <div className="password-container">
                  <input
                    type={passwordShow ? "text" : "password"}
                    className="password-login"
                    placeholder="Enter your password"
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  <span
                    className="toggle-password"
                    onClick={() => setPasswordShow(!passwordShow)}
                  >
                    <img
                      src={passwordShow ? view : hide}
                      width={20}
                      alt="Toggle visibility"
                    />
                  </span>
                </div>

                {passwordError && <p className="error">{passwordError}</p>}
                {LoginError && <p className="setLoginErrroColor">{LoginError}</p>}
                <h6 ><span className="registrationPagedetails-Text" onClick={handleForgot}>Forgot Password ?</span></h6>
                <div className="row setCenterTheButton">
                  <div className="col-md-4">
                    <button className={`btn-verify-email ${loginLoading ? 'loading' : ''}`} disabled={loginLoading}>
                      {loginLoading ? (
                        <>
                          <div className="spinner"></div>
                          Logging In...
                        </>
                      ) : (
                        'Log In'
                      )}
                    </button>
                  </div>
                </div>

                <div className="register"> <div className="google-login-container d-flex justify-content-center my-3">
                  <GoogleLogin
                    onSuccess={handleGoogleSuccess}
                    onError={() => toast.error("Google Login Failed")}
                    useOneTap
                  />
                </div>
                  {/* <p>
                    <span className="pl-4">
                      Don't have an account ?
                    </span>
                    <span className="ml-3 text-decoration-underline" style={{ cursor: "pointer" }} onClick={handleSwitch}>Register</span>
                  </p> */}
                </div>
              </form>
            </div>
          ) : isSignup == "forgot" ? (
            <div className="login-form">
              <div className="close-icon" onClick={closeModal} style={{ cursor: "pointer" }}>
                <img src={closeIcon} alt="Close" onClick={closeModal} />
              </div>
              <div className="login-logo col-md-12">
                <div className="row ">
                  <img className="logoImage" src={logo} />
                  <h4>Forgot Password</h4>
                </div>

              </div>
              <div>

                <div>
                  <span className="registrationPagedetails-Text">Please enter your registered email address</span>
                </div>
              </div>
              <form onSubmit={handleVerifyEmailId}>
                <div className="email-input">
                  <input
                    type="text"
                    className="email-login"
                    placeholder="Enter your email"
                    value={email}
                    onChange={handleEmailChange}
                  />
                </div>
                {emailError && <p className="error">{emailError}</p>}
                <div className="row setCenterTheButton">
                  <div className="col-md-3">
                    <button className={`btn-verify-email ${verifyEmailLoading ? 'loading' : ''}`} disabled={emailError || verifyEmailLoading}>
                      {verifyEmailLoading ? (
                        <>
                          <div className="spinner"></div>
                          Verifying...
                        </>
                      ) : (
                        'Verify Email'
                      )}
                    </button>
                  </div>
                </div>
                <div className="register">
                  <span className="pl-4" onClick={handleToggle}>
                    Remember Password{" "}?Login
                  </span>
                </div>
              </form>
            </div>
          ) : isSignup == "verifyEmail" ? (
            <div className="login-form">
              <div className="close-icon" onClick={closeModal} style={{ cursor: "pointer" }}>
                <img src={closeIcon} alt="Close" onClick={closeModal} />
              </div>

              <div className="login-logo">
                <img src={logo} alt="Logo" />
              </div>

              <div className="text-center">
                <h3 className="form-title">Reset Password</h3>
              </div>
              <form onSubmit={submitOtp} className="form-content">
                <div className="email-input">
                  <label className="form-label">Enter OTP</label>
                  <div className="otp-input-wrapper">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        inputMode="numeric"
                        maxLength="2"
                        className="otp-box"
                        value={digit}
                        onChange={(e) => handleOtpChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        ref={(el) => (inputRefs.current[index] = el)}
                      />
                    ))}
                  </div>
                  {OTPError && <p className="error">{OTPError}</p>}
                  <div className="otp-modern-bottom">
                    {timeLeft > 0 ? (
                      <p className="otp-modern-timer">
                        Resend in: <strong>{Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}</strong>
                      </p>
                    ) : (
                      <p className="otp-modern-resend-wrapper">
                        Haven’t received your code?{" "}
                        <span className="otp-modern-resend" onClick={handleResendotp}>
                          Resend OTP
                        </span>
                      </p>
                    )}

                  </div>

                </div>
                <div className="email-input">
                  <label className="form-label" >New Password</label>
                  <div className="password-container">
                    <input
                      type={passwordShow4 ? "text" : "password"}
                      className="password-login"
                      placeholder="Enter your new password"
                      value={newPassword}
                      onChange={handleNewPasswordChange}
                    />
                    <span
                      className="toggle-password"
                      onClick={() => setPasswordShow4(!passwordShow4)}
                    >
                      <img
                        src={passwordShow4 ? view : hide}
                        width={20}
                        alt="Toggle visibility"
                      />
                    </span>
                  </div>
                </div>
                {newPasswordError && <p className="error">{newPasswordError}</p>}
                <div className="email-input">
                  <label className="form-label" >Confirm Password</label>
                  <div className="password-container">
                    <input
                      type={passwordShow ? "text" : "password"}
                      className="password-login"
                      placeholder="Enter your password"
                      value={confirmNewPassword}
                      onChange={handleConfirmNewPasswordChange}
                    />
                    <span
                      className="toggle-password"
                      onClick={() => setPasswordShow(!passwordShow)}
                    >
                      <img
                        src={passwordShow ? view : hide}
                        width={20}
                        alt="Toggle visibility"
                      />
                    </span>
                  </div>
                </div>
                {conformNewPasswordError && <p className="error">{conformNewPasswordError}</p>}
                {/* Confirm Password */}
                {/* Submit Button */}

                <div className="row setCenterTheButton">
                  <div className="col-md-3">
                    <button type="submit" className={`btn btn-verify-email ${submitOtpLoading ? 'loading' : ''}`} disabled={submitOtpLoading}>
                      {submitOtpLoading ? (
                        <>
                          <div className="spinner" style={{ borderTopColor: '#ffffff' }}></div>
                          Submitting...
                        </>
                      ) : (
                        'Verify & Submit'
                      )}
                    </button>
                  </div>
                </div>

              </form>
            </div>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <div className="otp-modern-container">
          <div className="otp-modern-card">
            <img src={logo} className="otp-modern-logo" />

            <h2 className="otp-modern-title">Verify Your Email</h2>
            <p className="otp-modern-text">
              Enter the 6-digit code sent to <strong style={{ color: "var(--color-turquoise-teal)" }}>{email}</strong>.
            </p>

            <div className="otp-modern-input-wrapper">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  inputMode="numeric"
                  maxLength="2"
                  className="otp-modern-box"
                  value={digit}
                  onChange={(e) => handleOtpChange2(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (inputRefs.current[index] = el)}
                />
              ))}
            </div>

            {OTPError && <p className="otp-modern-error">{OTPError}</p>}

            <div className="otp-modern-bottom">
              {timeLeft > 0 ? (
                <p className="otp-modern-timer">
                  Resend in: <strong>{Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}</strong>
                </p>
              ) : (
                <p className="otp-modern-resend" onClick={handleResendotp}>
                  Resend OTP
                </p>
              )}
            </div>

            {/* BUTTON */}
            <button
              className="btn-verify-email"
              onClick={verifyOtp}
            >
              Verify OTP
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Authentication;

